import React, { useContext, useEffect, useState } from "react";
import { View, Text, StatusBar, ScrollView } from "react-native";
import { Avatar } from "react-native-elements";
import { useNavigation } from "@react-navigation/native";
import { Feather as Icons, FontAwesome5, MaterialCommunityIcons } from "@expo/vector-icons";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";

import Profile from "../../Profile";
import SelectDriverDriver from "../AddRoute/SelectDriver";

import { Header, CardDelivery, Container, Content, TabBar } from "../../../components";
import {
  HeaderInfos,
  TextWelcome,
  NameUser,
  IconFE,
  TitleMain,
  Deliveries,
  OrderingOptions,
  TextPending,
  TextHandedOut,
  ButtonTextHandedOut,
  ButtonTextPending,
} from "./styles";
import UserContext from "../../../context/user";
import RouteContext from "../../../context/route";
import ClientContext from "../../../context/client";

function DashboardDriver() {
  const navigation = useNavigation();
  const { user } = useContext(UserContext);
  const { getIndividualOrder, pendingOrders, completeOrders } = useContext(RouteContext);
  const { clients } = useContext(ClientContext);
  
  const [deliveryType, setDeliveryType] = useState(0);
  
  function handlePending() {
    setDeliveryType(0);
  }

  function handleHandedOut() {
    setDeliveryType(1);
  }

  async function handleDetailsDelivery(id: number) {
    try {
      await getIndividualOrder(id);
      navigation.navigate('DetailsDeliveryAdmin', {});
    } catch (_) {
      console.log('error getIndividualOrder screen');
    }
  }

  useEffect(() => {
    // const unsubscribe = navigation.addListener('focus', () => {
      console.log('route')
    // });

    // return unsubscribe;
  }, [navigation]);

  return (
    <Container>
      <Header />
      <Content>
        <TitleMain>
          <Deliveries>Entregas</Deliveries>

          <OrderingOptions>
            <ButtonTextPending onPress={handlePending}>
                <TextPending deliveryType={deliveryType}>Pendentes</TextPending>
            </ButtonTextPending>
            <ButtonTextHandedOut onPress={handleHandedOut}>
                <TextHandedOut deliveryType={deliveryType}>Entregues</TextHandedOut>
            </ButtonTextHandedOut>
          </OrderingOptions>
        </TitleMain>

        <ScrollView showsVerticalScrollIndicator={false}>
            {deliveryType === 0 ? (
                <>
                  {pendingOrders.map((item: any, index: number) => {
                    const date = new Date(item.date_order);
                    return (
                      <CardDelivery
                        key={index}
                        name={item.destiny_name}
                        date={date.toLocaleDateString()}
                        status={item.order_status}
                        city={`${item.destiny_city} - ${item.destiny_state}`}
                        onPress={() => handleDetailsDelivery(item.id)}
                      />
                    )
                  })}
                </>
            ) : (
                <>
                  {completeOrders.map((item: any, index: number) => {
                    const date = new Date(item.date_order);
                    return (
                      <CardDelivery
                        key={index}
                        name={item.destiny_name}
                        date={date.toLocaleDateString()}
                        status={item.order_status}
                        city={`${item.destiny_city} - ${item.destiny_state}`}
                        onPress={() => handleDetailsDelivery(item.id)}
                      />
                    )
                  })}
                </>
            )}
        </ScrollView>
      </Content>
    </Container>
  );
}

const Tab = createBottomTabNavigator();

export default function App() {
  return (
    <Tab.Navigator
      screenOptions={{ headerShown: false }}
      tabBar={(props) => <TabBar {...props} />}
    >
      <Tab.Screen
        name="Entregas"
        component={DashboardDriver}
        options={{
          tabBarIcon: ({ focused }) => {
            return (
              <Icons
                name="menu"
                size={25}
                color={focused ? "#3F50B5" : "gray"}
              />
            );
          },
        }}
      />
      <Tab.Screen
        name="Rotas"
        component={SelectDriverDriver}
        options={{
          tabBarIcon: ({ focused }) => {
            return (
              <MaterialCommunityIcons
                name="map-marker-path"
                size={25}
                color={focused ? "#3F50B5" : "gray"}
              />
            );
          },
        }}
      />
      <Tab.Screen
        name="Perfil"
        component={Profile}
        options={{
          tabBarIcon: ({ focused }) => {
            return (
              <FontAwesome5
                name="user-circle"
                size={25}
                color={focused ? "#3F50B5" : "gray"}
              />
            );
          },
        }}
      />
    </Tab.Navigator>
  );
}
